(function () {
  'use strict';

  const CONFIG = {
    maxFileSize: 10 * 1024 * 1024,
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
    timeouts: {
      getSignedUrlMs: 10000,
      uploadMs: 20000,
      apiRequestMs: 180000,
    },
  };

  let selectedFile = null;
  let uploadedImageUrl = null;

  function init() {
    if (typeof jQuery === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    jQuery(document).ready(function () {
      setupImageUpload();
      setupGenerate();
      updateCost();
    });
  }

  function setupImageUpload() {
    jQuery('#reference-image-input').on('change', function (e) {
      const file = e.target.files[0];
      if (file) handleFileSelection(file);
    });

    const dropZone = jQuery('#image-drop-zone');

    dropZone.on('click', function (e) {
      if (
        e.target.id === 'reference-image-input' ||
        jQuery(e.target).closest('#reference-image-input').length
      )
        return;
      if (!selectedFile) jQuery('#reference-image-input').trigger('click');
    });

    dropZone.on('dragover', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).addClass('drag-over');
    });

    dropZone.on('dragleave', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).removeClass('drag-over');
    });

    dropZone.on('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).removeClass('drag-over');
      const files = e.originalEvent.dataTransfer.files;
      if (files.length > 0) handleFileSelection(files[0]);
    });

    jQuery('#remove-image').on('click', function (e) {
      e.stopPropagation();
      removeSelectedImage();
    });

    document.addEventListener('imageFilePasted', function (event) {
      try {
        const blob = event && event.detail && event.detail.file;
        if (!blob || !blob.type || !blob.type.startsWith('image/')) return;
        let file = blob;
        if (!('name' in blob) || !blob.name) {
          const ext = (blob.type.split('/')[1] || 'png').replace(
            /[^a-z0-9]/gi,
            ''
          );
          const generatedName = `pasted-image-${Date.now()}.${ext}`;
          try {
            file = new File([blob], generatedName, { type: blob.type });
          } catch {
            try {
              Object.defineProperty(blob, 'name', { value: generatedName });
            } catch {}
            file = blob;
          }
        }
        handleFileSelection(file);
      } catch {}
    });

    document.addEventListener('paste', function (event) {
      if (!event.clipboardData || !event.clipboardData.items) return;
      const items = Array.from(event.clipboardData.items);
      const imageItem = items.find(
        (item) => item.type && item.type.startsWith('image/')
      );
      if (!imageItem) return;
      const blob = imageItem.getAsFile();
      if (blob) handleFileSelection(blob);
    });
  }

  function handleFileSelection(file) {
    if (!CONFIG.allowedTypes.includes(file.type)) {
      showNotification('Unsupported file type', 'error');
      return;
    }
    if (file.size > CONFIG.maxFileSize) {
      showNotification('File too large', 'error');
      return;
    }
    selectedFile = file;
    uploadedImageUrl = null;
    jQuery('#image-name').text(file.name);
    const img = document.getElementById('preview-img');
    img.src = URL.createObjectURL(file);
    jQuery('#upload-placeholder').hide();
    jQuery('#image-preview').show();
    jQuery('#image-drop-zone').addClass('has-image');
  }

  function removeSelectedImage() {
    selectedFile = null;
    uploadedImageUrl = null;
    jQuery('#reference-image-input').val('');
    jQuery('#image-preview').hide();
    jQuery('#upload-placeholder').show();
    jQuery('#image-drop-zone').removeClass('has-image');
  }

  function compressImageToWebP(file, quality) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error('compress failed'));
            const baseName =
              file && file.name ? file.name : `ltx2-${Date.now()}.png`;
            const safeName = baseName.replace(/\.[^/.]+$/, '.webp');
            let compressedFile;
            try {
              compressedFile = new File([blob], safeName, {
                type: 'image/webp',
              });
            } catch {
              try {
                Object.defineProperty(blob, 'name', { value: safeName });
              } catch {}
              compressedFile = blob;
            }
            resolve(compressedFile);
          },
          'image/webp',
          quality
        );
      };
      img.onerror = () => reject(new Error('image load failed'));
      img.src = URL.createObjectURL(file);
    });
  }

  function removeSpecialUrlChars(name) {
    return name.replace(/[,!#$%^&*(){}[\]<>;'?=":]/g, '').replace(/\s+/g, '-');
  }

  async function getSignedUploadUrl(contentType, fileName) {
    const url =
      '/file-upload-get-signed-url-cloudflare?' +
      new URLSearchParams({ file_type: contentType, file_name: fileName });
    const response = await fetchWithTimeout(
      url,
      { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      CONFIG.timeouts.getSignedUrlMs
    );
    if (!response.ok) throw new Error(`Signed URL error: ${response.status}`);
    return response.json();
  }

  async function uploadToR2(file, type, name) {
    const signedUrl = await getSignedUploadUrl(type, name);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl.url, true);
      xhr.timeout = CONFIG.timeouts.uploadMs;
      xhr.onload = () => {
        if (xhr.status === 200) {
          const bucket = signedUrl.bucket_name || 'netwrckstatic.netwrck.com';
          resolve({ url: `https://${bucket}/${signedUrl.object_path}` });
        } else {
          reject(new Error(`Upload failed: ${xhr.status}`));
        }
      };
      xhr.onerror = () => reject(new Error('Upload failed'));
      xhr.ontimeout = () => reject(new Error('Upload timed out'));
      xhr.setRequestHeader('Content-Type', type);
      xhr.send(file);
    });
  }

  async function uploadImage() {
    if (!selectedFile) return null;
    showNotification('Compressing image...', 'info');
    const compressed = await compressImageToWebP(selectedFile, 0.85);
    showNotification('Uploading...', 'info');
    const fallbackName = `ltx2-${Date.now()}.webp`;
    const fileName = removeSpecialUrlChars(compressed.name || fallbackName);
    const result = await uploadToR2(compressed, 'image/webp', fileName);
    uploadedImageUrl = result.url;
    return uploadedImageUrl;
  }

  function fetchWithTimeout(resource, options, timeoutMs) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeoutMs);
    const opts = { ...options, signal: controller.signal };
    return fetch(resource, opts).finally(() => clearTimeout(id));
  }

  function showNotification(message, type) {
    if (
      window.NetwrckTools &&
      typeof window.NetwrckTools.showNotification === 'function'
    ) {
      window.NetwrckTools.showNotification(message, type || 'info');
      return;
    }
    if (typeof window.showSnackbar === 'function') {
      window.showSnackbar(message);
      return;
    }
    if (type === 'error') {
      alert(message);
    }
  }

  function setupGenerate() {
    jQuery('#ltx2-generate').on('click', generateVideo);
    jQuery('#ltx2-duration, #ltx2-resolution').on('change', updateCost);
  }

  function updateCost() {
    const duration = parseFloat(jQuery('#ltx2-duration').val()) || 6;
    const resolution = jQuery('#ltx2-resolution').val() || '1080p';
    const base =
      resolution === '1440p' ? 0.12 : resolution === '2160p' ? 0.24 : 0.06;
    const cost = base * duration * 1.2;
    jQuery('#ltx2-cost').text(`$${cost.toFixed(2)}`);
  }

  function getAuthSecret() {
    const creds =
      typeof window.getAuthCredentials === 'function'
        ? window.getAuthCredentials()
        : null;
    if (creds && creds.secret) return creds.secret;
    if (window.userData && window.userData.secret)
      return window.userData.secret;
    return '';
  }

  async function generateVideo() {
    const prompt = jQuery('#ltx2-prompt').val().trim();
    if (!prompt) {
      showNotification('Enter a prompt', 'error');
      return;
    }

    const duration = parseFloat(jQuery('#ltx2-duration').val()) || 6;
    const resolution = jQuery('#ltx2-resolution').val() || '1080p';
    const mode = jQuery('#ltx2-mode').val() || 'image-to-video';
    const base =
      resolution === '1440p' ? 0.12 : resolution === '2160p' ? 0.24 : 0.06;
    const cost = base * duration * 1.2;
    const credits = Math.ceil(cost * 100);

    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      if (window.showSubscribeDialog) window.showSubscribeDialog();
      return;
    }
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, cost.toFixed(2))
    )
      return;

    let imageUrl = uploadedImageUrl;
    if (mode === 'image-to-video') {
      if (!imageUrl) {
        try {
          imageUrl = await uploadImage();
        } catch (err) {
          showNotification('Image upload failed', 'error');
          return;
        }
      }
      if (!imageUrl) {
        showNotification('Upload an image first', 'error');
        return;
      }
    }

    jQuery('#ltx2-loading').show();
    jQuery('#generation-logs').empty().show();
    appendLog('Submitting request...');

    const payload = {
      api_key: secret,
      prompt,
      image_url: imageUrl || undefined,
      duration,
      resolution,
      aspect_ratio: '16:9',
      fps: parseInt(jQuery('#ltx2-fps').val(), 10) || 25,
      generate_audio: true,
      mode,
      response_mode: 'polling',
    };

    const response = await fetch('/api/ltx-2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': secret,
        Authorization: `Bearer ${secret}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (response.status === 202 && data.job_id) {
      appendLog('Job queued');
      pollJob(data.job_id, secret);
      return;
    }

    const url = data.result?.video?.url || data.video?.url || data.video_url;
    if (url) {
      showVideo(url);
    } else {
      appendLog('Generation failed');
    }
    jQuery('#ltx2-loading').hide();
  }

  function appendLog(text) {
    const logs = jQuery('#generation-logs');
    logs.append(`<div>${text}</div>`);
  }

  function pollJob(jobId, secret) {
    fetch(`/api/fal/status/${jobId}?api_key=${encodeURIComponent(secret)}`)
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status === 'completed') {
          const url =
            data.result?.video?.url ||
            data.result?.result?.video?.url ||
            data.result?.video_url;
          if (url) {
            showVideo(url);
            appendLog('Generation complete');
          } else {
            appendLog('No video in result');
          }
          jQuery('#ltx2-loading').hide();
          return;
        }
        if (data.status === 'failed') {
          appendLog('Generation failed');
          jQuery('#ltx2-loading').hide();
          return;
        }
        appendLog('Working...');
        setTimeout(() => pollJob(jobId, secret), 4000);
      })
      .catch(() => {
        setTimeout(() => pollJob(jobId, secret), 6000);
      });
  }

  function showVideo(videoUrl) {
    const videoHtml = `<div class="ai-video-item mdl-cell mdl-cell--stretch mdl-cell--12-col mdl-list__item"><video controls autoplay loop style="max-width: 100%;"><source src="${videoUrl}" type="video/mp4"></video></div>`;
    jQuery('#createdVideoList').prepend(videoHtml);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
